/**
 * "1 contact", "3 contacts", "0 companies". Takes both forms because the wizard's nouns are not
 * regular ("company" → "companies").
 */
export function countNoun(count: number, singular: string, plural: string): string {
  return `${count} ${count === 1 ? singular : plural}`
}
